<template>
    <div class="modal-onboarding modal fade animate__animated" id="onboardHorizontalImageModal" tabindex="-1"
        ref="modalEle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body onboarding-horizontal p-0">
                    <div class="onboarding-content mb-0">
                        <slot name="body" />
                    </div>
                </div>
                <div class="modal-footer border-0 mt-3">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { Modal } from "bootstrap";
defineProps({
    title: {
        type: String,
        default: "<<Title goes here>>",
    },
});
let modalEle = ref(null);
let thisModalObj = null;

onMounted(() => {
    thisModalObj = new Modal(modalEle.value);
});
function _show() {
    thisModalObj.show();
}

function _close() {
    thisModalObj.hide()
}

defineExpose({ show: _show, close: _close });
</script>